import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';

import './Landing.css';

class Footer extends Component {
  render() {
    return (
      <footer className="Landing-footer">
        <Grid>
          <Row>
            <Col lg={12}>
              <div>Passcode Technologies Inc. 2018 ©</div>
              <div>All rights reserved.</div>
              {this.renderLink("/terms", "Terms")}
              {this.renderLink("/privacy", "Privacy")}
            </Col>
          </Row>
        </Grid>
      </footer>
    );
  }

  renderLink = (to, text) => {
    return (
      <Link to={to} style={{
        color: "white",
        textDecoration: "underline",
        marginRight: "15px"
      }}>{text}</Link>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/entries/Static/Footer.js